<template>
    <div class="widthawalBind" ref="widthawalBind">
        <div class="forbidden-box" v-if="status == 1">
            <span class="title">
                禁用抖音商户
                <el-popover width="400" placement="top-start" trigger="hover" >
                    <span>禁用该抖音商户之后，订单收益将不再入账该商户，但不影响该商户已有资金的分账和提现；禁用操作之前，请确保有其他商户可以承接收益入账，否则不支持禁用操作。</span>
                    <div slot="reference" class="question">?</div>
                    <!-- <img slot="reference"   class="question" src="http://img-dbzd.doubaozhidao.com/20220815/rAaEw2JCF5WcD7sTaxjMYShkmnARrmM21660554235278.png?x-oss-process=image/quality,q_80/format,png" alt=""> -->
                </el-popover>
            </span>
            <!-- <el-switch @click="console.log(111)" @change="changeForbidden()" v-model="forbiddenShoper"></el-switch> -->
            <img @click="changeForbidden" class="forbidden-btn" v-if="!forbiddenShoper" src="http://img-dbzd.doubaozhidao.com/20230410/1681098244115312.png" alt="">
            <img @click="changeForbidden" class="forbidden-btn" v-else src="http://img-dbzd.doubaozhidao.com/20230410/1681098222457218.png" alt="">
        </div>
        <iframe id="iframe" :src="url" width="100%" height="100%" frameborder="0" scrolling="auto" border="0" allowtransparency="yes" marginheight="0" marginwidth="0"></iframe>
        <div v-if="forbiddenShoper" class="mask"></div>
        <div v-if="forbiddenShoper" class="forbidden-dialog-box">
            <h3 class="title">该商户已被禁用</h3>
            <div slot="footer" class="dialog-footer">
                <el-button @click="diaClickBtn(1)" class="left-btn" type="primary">
                    启用商户
                    <el-popover width="400" placement="top-start" trigger="hover" >
                        <span>启用该抖音商户之后，订单收益将入账该商户，正常执行分账和提现操作</span>
                        <div slot="reference" class="question">?</div>
                        <!-- <img slot="reference"   class="question" src="http://img-dbzd.doubaozhidao.com/20220815/rAaEw2JCF5WcD7sTaxjMYShkmnARrmM21660554235278.png?x-oss-process=image/quality,q_80/format,png" alt=""> -->
                    </el-popover>
                </el-button>
                <el-button @click="diaClickBtn(2)" type="primary">
                    删除商户
                    <el-popover width="400" placement="top-start" trigger="hover" >
                        <span>删除商户之前，请确保该商户资金已提现完成，若商户还存在资金将不支持删除，删除之后不可恢复，请谨慎操作</span>
                        <div slot="reference" class="question">?</div>
                        <!-- <img slot="reference"   class="question" src="http://img-dbzd.doubaozhidao.com/20220815/rAaEw2JCF5WcD7sTaxjMYShkmnARrmM21660554235278.png?x-oss-process=image/quality,q_80/format,png" alt=""> -->
                    </el-popover>
                </el-button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions} from 'vuex'
export default {
    data() {
        return {
            url: '',
            forbiddenShoper:false,
			status: ''
			
        }
    },
    created() {
		this.status = this.$route.params.status
        this.getMerchantAddhtml()
        this.$nextTick(() => {
            document.body.classList.add('widthawalBind_content_index')
        })
        this.checkForbiddenStatus()
    },
    beforeRouteLeave(to,form,next) {
        document.body.classList.remove('widthawalBind_content_index')
        next()
    },
    methods: {
        ...mapActions('dataCenter', ['merchantAddhtml', 'addSubMerchant','merchantStatus']),
        async getMerchantAddhtml() {
            let res = ''
            if(this.$route.params.id) {
                res = await this.addSubMerchant({id: this.$route.params.id})
            } else {
                res = await this.addSubMerchant()
            }
            this.url = res.url
            // console.log('this.url:',this.url)
        },
        async setMerchantStatus(statusType){
            let res=await this.merchantStatus({id: this.$route.params.id, status_type: statusType})
            console.log('res:',res)
        },
        checkForbiddenStatus(){
            if(this.$route.params.status_type==2){
                this.forbiddenShoper=true
            }
        },
        changeForbidden(){
            if(!this.forbiddenShoper){
                this.$confirm('禁用该抖音商户之后，订单收益将不再入账该商户，但不影响该商户已有资金的分账和提现；请谨慎操作。', '禁用确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    // type: 'warning'
                }).then(() => {
                    // 此处塞接口，需要根据响应数据判断，可能会禁用失败
                    this.setMerchantStatus(2).then(()=>{
                        console.log('禁用成功')
                        this.forbiddenShoper=true
                        this.$message({
                            type: 'success',
                            message: '禁用成功!'
                        });
                    }).catch(()=>{
                        console.log('禁用失败')
                    })
                }).catch(() => {
                    this.forbiddenShoper=false
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });    
                });
            }else{
                this.forbiddenShoper=false
            }
        },
        diaClickBtn(status){
            // this.forbiddenDialogVisible = false
            if(status==1){
                // console.log('启用')
                this.$confirm('确认启用该抖音商户嘛？', '启用确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    // type: 'warning'
                }).then(() => {
                    // 此处塞接口，需要根据响应数据判断，可能会启用失败（网络波动什么的）
                    this.setMerchantStatus(1).then(()=>{
                        console.log('启用成功')
                        this.$message({
                            type: 'success',
                            message: '启用成功!'
                        });
                        this.forbiddenShoper=false
                        this.forbiddenDialogVisible = false
                    }).catch(()=>{
                        console.log('启用失败')
                    })
                    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });    
                });
            }else{
                // console.log('删除')
                this.$confirm('删除之前请确认该商户无在途资金和提现资金', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    // type: 'warning'
                }).then(() => {
                    // 此处塞接口，需要根据响应数据判断，可能会删除失败
                    this.setMerchantStatus(3).then(()=>{
                        console.log('删除成功')
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.$router.push(this.staticPath+'withdrawalSettings')
                    }).catch(()=>{
                        console.log('启用失败')
                    })

                    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });    
                });
            }
        }
    }
}
</script>
<style lang="less">
.widthawalBind_content_index {
    .content {
        max-width: 1460px!important;
        min-width: 1460px!important;
        .content_right {
            padding: 0 0 0 20px!important;
            .content_right_con {
                padding:20px 0!important;
            }
        }
    }
}
</style>
<style lang="less" scoped>
    .widthawalBind {
        width: 100%;
        height: 100%;
        position: relative;
        .forbidden-box{
            padding-bottom: 15px;
            padding-left: 30px;
            position: relative;
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
            .question{
                background-color: #d1d1d1;
                border-radius: 50%;
                width: 20px;
                height: 20px;
                text-align: center;
                font-size: 14px;
            }
            .title{
                display: flex;
                align-items: center;
                font-size: 18px;
                font-weight: 600;
                margin-right: 20px;
            }
            .forbidden-btn{
                width: 37px;
                cursor: pointer;
            }
        }
        .forbidden-dialog-box{
            position: fixed;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%) !important;
            // margin-top: 150px;
            width: 300px;
            height: 155px;
            background-color: #fff;
            padding: 45px 30px 0;
            .title{
                text-align: center;
                font-weight: normal;
            }
            .dialog-footer{
                margin-top: 60px;
                display: flex;
                justify-content: center;
                .question{
                    background-color: #d1d1d1;
                    border-radius: 50%;
                    width: 16px;
                    height: 16px;
                    text-align: center;
                    font-size: 12px;
                    line-height: 17px;
                    color: #333;
                    display: inline-block;
                }
                .left-btn{
                    margin-right: 30px;
                }
            }
        }
        .mask{
            width: 100%;
            height: 122%;
            background-color: #cecece95;
            position: absolute;
            left: 0;
            top: -22px;
        }
    }
</style>